import { render, staticRenderFns } from "./CaseTrackUpdate.vue?vue&type=template&id=2a490c4b&"
import script from "./CaseTrackUpdate.vue?vue&type=script&lang=js&"
export * from "./CaseTrackUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports